import { Box, Button, Container, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { withWidth } from "@material-ui/core";
import JoinTheWaitlistButton from "../../../../components/buttons/JoinTheWaitlist";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles(() => ({
  textMonarcha: {
    fontFamily: "monarcha,open-sans !important",
    textTransform: "uppercase !important",
    color: "white",
    fontWeight: "bold !important",
    textAlign: "center",
  },
  textOpenSans: {
    fontFamily: "open-sans,san-serif !important",
    textTransform: "normal",
    color: "white",
  },
  glow: {
    textShadow: "0 0 0.1vw #fff, 0 0 0.05vw #fff, 0 0 1.1vw #ffbf12",
  },
}));

const Creators__OpeningSlide = ({ width, ...props }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <Container sx={{ marginBottom: width !== "xl" ? 5 : 7 }}>
        <Typography
          variant={width === "xs" ? "h2" : width !== "xl" ? "h2" : "h4"}
          className={classes.textMonarcha + " " + classes.glow}
          sx={{
            fontSize:
              width === "xs"
                ? "2.2rem"
                : width !== "xl"
                ? "3.75rem"
                : "2.125rem",
            lineHeight: width === "xs" ? 1.15 : 1.15,
            marginBottom: width === "xs" ? 0.75 : 0.75,
          }}
        >
          Turn socials to stocks
        </Typography>
        <Typography
          variant={width === "xs" ? "h5" : width !== "xl" ? "h4" : "h6"}
          className={classes.textMonarcha}
          sx={{
            color: "#ffffff44",
            lineHeight: width === "xs" ? 1.4 : 1.1,
            fontSize:
              width === "xs"
                ? "1.15rem !important"
                : width !== "xl"
                ? "1.5rem !important"
                : "1.25rem !important",
          }}
        >
          AI Agent for creator monetization
        </Typography>
      </Container>

      <Box
        sx={{
          position: "absolute",
          bottom:
            width !== "xl"
              ? "calc(90px + env(safe-area-inset-bottom))"
              : "calc(0px + env(safe-area-inset-bottom))",
        }}
      >
        <Container sx={{ marginBottom: "1.5rem" }}>
          <Typography
            variant={width === "xs" ? "h2" : width !== "xl" ? "h2" : "h4"}
            className={classes.textMonarcha + " " + classes.glow}
            sx={{
              fontSize:
                width === "xs"
                  ? "2.2rem"
                  : width !== "xl"
                  ? "3.75rem"
                  : "2.125rem",
              lineHeight: width === "xs" ? 1.15 : 1.15,
              marginBottom: width === "xs" ? 0.75 : 0.75,
            }}
          >
            Our Beta is Live!
          </Typography>{" "}
          <Button
            className={classes.textOpenSans}
            sx={{
              textTransform: "none",
              color: "black",
              fontSize: "16px",
              lineHeight: 2.1,
              padding: "5px 65px",
              background: "#ffbf12",
              borderRadius: "50px",
              margin: "20px auto",
              display: "block",
              "&:hover": { background: "#ffbf12" },
            }}
            onClick={() => {
              window.open("https://passionstocks.com");
            }}
          >
            Sign Up / Log In
          </Button>
        </Container>{" "}
        {/* <JoinTheWaitlistButton /> */}
      </Box>
    </Box>
  );
};
export default withWidth()(Creators__OpeningSlide);
